import { arrow, closeIcon } from "@/designSystemIcons";
import { cn } from "@/lib/utils";
import { BREAKPOINTS } from "@/settings";
import React from "react";
import { useMediaQuery } from "usehooks-ts";

const HeaderBar = ({
  onBack,
  title,
  right,
  sbcFiltersIsToggled,
  onToggleFilters,
}: {
  onBack: () => void;
  title: string;
  right?: React.ReactNode;
  sbcFiltersIsToggled: boolean;
  onToggleFilters?: () => void;
}) => {
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);
  const isTouch = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);

  if (isMobile && sbcFiltersIsToggled) {
    return (
      <div className="relative w-full bg-panel-base z-50">
        <div className="min-h-12 flex w-full items-center justify-between px-4 max-w-content">
          <div className="min-w-5" />
          <span className="text-base">Settings</span>
          <button
            onClick={onToggleFilters}
            className="flex px-1 cursor-pointer"
          >
            <div className="w-3 text-dark-tertiary">{closeIcon}</div>
          </button>
        </div>
      </div>
    );
  }

  if (isMobile) {
    return (
      <div className="relative w-full bg-panel-base">
        <div className="min-h-12 flex w-full items-center justify-between">
          <button onClick={onBack} className="flex py-3 p-4 cursor-pointer">
            <div className="w-3 rotate-90 text-dark-tertiary">{arrow}</div>
          </button>
          <span className="text-base">{title}</span>
          <div className="min-w-11" />
        </div>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "absolute w-full inset-x-0 top-12 mb-10",
        isTouch ? "top-0" : "top-12",
      )}
    >
      <div className="w-full bg-[#052432]/70">
        <div className="min-h-10 flex w-full items-center">
          <div className="mx-auto w-full max-w-content flex items-center justify-between">
            <div className="flex items-center">
              <button
                onClick={onBack}
                className="flex py-3 px-4 cursor-pointer"
              >
                <div className="w-3 rotate-90 text-dark-tertiary">{arrow}</div>
              </button>
              <div className="text-base">
                <span>EA FC 25 SBC Solution - </span>
                <span>{title}</span>
              </div>
            </div>
            {right}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderBar;
